<template>
  <div class="actionBox" @click="emitClickEvent($event)">
    <div
      class="actionBg"
      :class="[
        cssStyle,
        actionboxSmall ? 'actionBg-isSmall' : '',
        disabled ? 'actionBox-disabled' : ''
      ]"
    >
      <div class="actionText">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { cssVarBoolean } from "@/utils/helpers";

export default {
  name: "ActionBox",
  props: {
    cssStyle: String,
    disabled: Boolean
  },
  computed: {
    actionboxSmall() {
      return cssVarBoolean("--component_ActionBox_actionBg_isSmall");
    }
  },
  methods: {
    emitClickEvent(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actionBox {
  display: flex;
}

.actionBg {
  background-position: center 25px;
  background-size: 87px 77px;
  background-color: #f39a00;
  color: #fff;
  font-family: var(--component_ActionBox_actionBg_font-family);
  font-size: var(--component_ActionBox_actionBg_font-size);
  width: 480px;
  height: 180px;
  border-radius: var(--component_ActionBox_actionBg_border-radius);
  text-transform: var(--component_ActionBox_actionBg_text-transform);
  display: flex;
  align-items: center;
  flex-direction: column;
  transform-origin: 50% 50%;
  justify-content: flex-end;
  padding-bottom: var(--component_ActionBox_actionBg_padding-bottom);
}

.actionText {
  pointer-events: none;
  font-family: var(--component_ActionBox_actionText_font-family);
  letter-spacing: 2.4px;
}
.more {
  background-color: var(--component_ActionBox_more_background-color);
  background-image: var(--component_ActionBox_more_background-image);
  background-repeat: no-repeat;
  color: var(--component_ActionBox_more_color);
}
.pay {
  background-color: var(--component_ActionBox_pay_background-color);
  background-image: var(--component_ActionBox_pay_background-image);
  background-position: center 32px;
  background-repeat: no-repeat;
  color: var(--component_ActionBox_pay_color);
}
.actionBox-disabled {
  opacity: 0.6;
  filter: grayscale(100%);
}
.payCikam {
  background-color: var(--component_ActionBox_payCikam_background-color);
  background-image: var(--component_ActionBox_payCikam_background-image);
  background-position: center 32px;
  background-repeat: no-repeat;
  color: var(--component_ActionBox_payCikam_color);
}
.ScanToiletVoucher {
  background-color: var(
    --component_ActionBox_ScanToiletVoucher_background-color
  );
  background-image: var(
    --component_ActionBox_ScanToiletVoucher_background-image
  );
  background-position: center 32px;
  background-repeat: no-repeat;
}
.ScanProduct {
  background-color: var(--component_ActionBox_ScanProduct_background-color);
  background-image: var(--component_ActionBox_ScanProduct_background-image);
  background-position: center 32px;
  background-repeat: no-repeat;
}
.ScanCoupon {
  background-color: var(--component_ActionBox_ScanCoupon_background-color);
  background-image: var(--component_ActionBox_ScanCoupon_background-image);
  background-position: center 32px;
  background-repeat: no-repeat;
  color: var(--component_ActionBox_ScanCoupon_color);
}
.actionBg-isSmall {
  height: 70px;
  border-radius: 35px;
  background-image: none;
  font-size: 42px;
  padding-bottom: 8px;
}
</style>
